import {Localize} from "@dp-instant/i18n";
import {Button} from "@dp-instant/ui";
import {SVG} from "@game/ui/images";
import {IClickableComponentProps} from "@game/ui/interface/IClickableComponentProps";
import cn from "classnames";
import {playUIClickSound} from "@game/helpers";
import {hapticMedium} from "@game/haptic";

interface IClaimButtonProps extends IClickableComponentProps {
    placement?: string;
    reward?: number;
    text?: string;
    multiplierText?: string;
    showIcom?: boolean;
    starsPrice?: number;
}

export const ClaimButton = ({
    onClick,
    className,
    placement,
    reward = 0,
    text = Localize.get("ui-win-claim", "CLAIM"),
    multiplierText = "X3",
    showIcom = true,
    starsPrice
}: IClaimButtonProps) => (
    <Button
        className={cn("btn-green", className, {"btn-multiline": reward})}
        onClick={() => {
            if (onClick) {
                playUIClickSound();
                hapticMedium();
                onClick();
            }
        }}
    >
        {showIcom && __SOCIAL__ !== "tg" ? <SVG.Video /> : null}
        {reward ? (
            <span className="column">
                <span className={cn("btn-content-title")}>
                    {text} {multiplierText}
                </span>
                <span className={cn("row", "row_centred")}>
                    <span className={cn("btn-content-important")}>{reward}</span>
                    <SVG.COINS className={cn("icon-coins")} />
                </span>
                {__SOCIAL__ === "tg" && starsPrice ? (
                    <span className="btn-stars-price">{starsPrice} ⭐</span>
                ) : null}
            </span>
        ) : (
            <span className="btn-content-title">
                {text}
                {__SOCIAL__ === "tg" && starsPrice ? ` ${starsPrice} ⭐` : null}
            </span>
        )}
    </Button>
);
